<div
  if.bind="subscriptions.limitReachedMessage"
  class="subscription-limit-toast"
  role="alert"
  aria-live="assertive">
  <span class="subscription-limit-toast__icon" aria-hidden="true">&#9888;</span>
  <p class="subscription-limit-toast__message">${subscriptions.limitReachedMessage}</p>
  <button
    type="button"
    class="subscription-limit-toast__dismiss"
    click.trigger="subscriptions.dismissLimitReached()"
    aria-label="Dismiss">&times;</button>
</div>
